import React from 'react';

import { getFeeMalls } from '../shared/models/feeMalls';

// 費用項目キーから、その項目がどのモールで発生するかを示す badge を表示する。
// 複数モールで発生する項目（例: 決済手数料は楽天とYahooの両方）は、該当モールを全て並べる。
// 全モール共通の項目には何も表示しない。
export default function MallBadge({ feeKey, className = '' }) {
  const malls = getFeeMalls(feeKey);
  if (malls.length === 0) return null;

  return (
    <>
      {malls.map(mall => (
        <span key={mall.label} className={`badge ${mall.className} ms-1 ${className}`} title={mall.title}>
          {mall.label}
        </span>
      ))}
    </>
  );
}
